// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 888 ? "98e2d21d" : chunkId) + "." + {"888":"dc3b79978098840f","2466":"a24aaee933c17d97","2642":"f035c92bcb79d038","6521":"c8a89a1be00bd4ec","7284":"c25a566ee786eec1","8210":"2be142aa0c81a409","8295":"bf59f4ad10dfc663"}[chunkId] + ".js";
};